<div class="web-center">
    <div [style]="isDesktop ? 'width: 90%; max-width: 1020px; display: flex; align-items: center; flex-direction: column;': 'width: 96%; overflow-x: hidden; min-height:30px'">


         <app-meals-search-bar *ngIf="!loading"
            [isMobile]="isMobile"
            [meals]="allMeals"
            [isCurrentMenu]="true"
            (selectedTagChange)="onMealsSearchChange($event)"
            (selectedCategoryChange)="onMealsSearchChange($event)"
            (selectedMealTypeChange)="onMealsSearchChange($event)"
            (searchChange)="onMealsSearchChange($event)"
            (searchReset)="resetSearch()">
        </app-meals-search-bar>


        <div>
            <ngx-spinner name="mealsSpinner" type="ball-spin-clockwise" bdColor="rgb(249, 249, 251)" size="medium" color="#ef870a" [fullScreen]="false" style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); z-index: 9999;"></ngx-spinner>
            <div class="meal-grid mt-4 mb-5" *ngIf="visualMeals.length>0">
                <app-new-meal-card
                    *ngFor="let meal of visualMeals"
                    [meal]="meal"
                    [isCurrentMenu]="true">
                </app-new-meal-card>
            </div>

            <div *ngIf="visualMeals.length==0 && !loading" class="d-flex flex-direction-column align-items-center">
                <span class="mb-4 mt-5">No meals found</span>
                <button class="btn btn-primary btn-add-to-cart weight-500 fm-prompt mb-4" (click)="resetSearch()">Clear search</button>
            </div>
        </div>
    </div>
</div>

<app-offer-banner link="/order-flow"/>
